<div class="container">
  <div class="modal-bienvenida slideIn" id="bienvenida">
    <div class="cerrar" (click)="cerrarModal()">x</div>
    <div class="img-container">
      <img
        src="../../../../assets/bienvenido.jpg"
        alt="Descripción de la imagen"
      />
    </div>

    <br />
    <h4>¡Completaste tu registro con éxito!</h4>

    <h5>Para comenzar necesitas habilitar facturación</h5>
    <br />

    <button
      mat-raised-button
      class="button"
      (click)="redirigirAHabilitarFacturacion()"
    >
      HABILITAR FACTURACIÓN
    </button>
  </div>
</div>
